import React from "react";
import NumberFormat from "react-number-format";
import Helper from "./Helper";
class ProductItem extends React.Component {
  constructor(props) {
    super(props);
  }
  addToCart=(item)=>{
    this.props.addToCart(item)
  }
  render() {
    let { product } = this.props,
    rating = product.meta.rating,
    rating_view = [];
    for (let i = 0; i < 5; i++) {
        let grayscale = rating <= i ? 'grayscale':''
        rating_view.push(
        <img key={i}
            src="/resource/images/ico_star_yellow.svg"
            className={`rating ${grayscale}`}
        />);
    }
    let progressRate = product.meta.sold/(product.meta.in_stock??1)*100;
    let progressTitleColor = product.meta.sold/(product.meta.in_stock??1)*100 >=50 ? "#fff" : "#676767";
    let discountPercent = 0;
    if(!product.meta.discount && product.meta.price > product.meta.price_after_discount){
      discountPercent = (product.meta.price - product.meta.price_after_discount)/product.meta.price;      
      product.meta.discount = discountPercent;
    }
  
    return (
      <div className="product-wrap__item product-wrap__item__3">
        <div className="product-style1 p-2 p-lg-4 mt-md-2 ml-md-2">
          <div className="product-style1__thumbnail position-relative w-100 mb-md-1">
            <a href={product.link}>
              <img
                src={product.image}
                alt={product.title}
                className="img-fluid"
              />
            </a>
            {product.meta.discount ? (
              <span className="position-absolute product-style1__discount">
                {product.meta.discount <= 1 ? (
                  `-${Math.ceil(product.meta.discount * 100)}%`
                ) : (
                  <NumberFormat
                    value={Math.round(product.meta.discount)}
                    thousandSeparator="."
                    decimalSeparator=","
                    displayType={"text"}
                    renderText={(value) => `-${value}đ`}
                  />
                )}
              </span>
            ) : null}
            {product.meta.out_of_stock ? (
              <span className="product-style1__out-of-stock">Cháy hàng</span>
            ) : null}
          </div>
          <div className="product-style1__text text-left px-md-2">
            <h3 className="product-style1__text__heading">
            <a className="product-style1__text__title" href={product.link}>
              {Helper.wordLimiter(product.title, 12)}
            </a>
            </h3>
            <p className="product-style1__text__price font-weight-bold">
              <NumberFormat
                value={Math.ceil(product.meta.price_after_discount)}
                thousandSeparator="."
                decimalSeparator=","
                displayType={"text"}
                renderText={(value) => `${value}đ`}
              />
            </p>
            {product.meta.price > product.meta.price_after_discount ? (
              <p className="product-style1__text__price-origin">
                <NumberFormat
                  value={Math.ceil(product.meta.price)}
                  thousandSeparator="."
                  decimalSeparator=","
                  displayType={"text"}
                  renderText={(value) => `${value}đ`}
                />
              </p>
            ) : <p className="product-style1__text__price-origin text-empty">&nbsp;</p>}
            <p className="product-style2__text__rating">
              {rating_view}
              <span className="rating-count text-warning">({product.meta.rating_amount})</span>
            </p>
            <div className="progress position-relative mt-2">
              <div
                className="progress-bar bg-danger text-center" style={{width: `${progressRate}%`}}
                role="progressbar"
                aria-valuenow={product.meta.sold}
                aria-valuemin={0}
                aria-valuemax={product.meta.in_stock}
              >
                <span
                  className="position-absolute"
                  style={{ left: "42%", color: progressTitleColor }}
                >
                  {product.meta.sold}/{product.meta.in_stock}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ProductItem;
